import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/students", label: "生徒一覧" }
];

export function AdminStudentDetailPage() {
  return (
    <PageScaffold
      title="Admin Student Detail"
      description="生徒詳細画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに生徒詳細を表示します。</p>
    </PageScaffold>
  );
}
